import { withStyles } from '@material-ui/core';

import DateForm from './component';
import styles from './styles';

export default withStyles(styles)(DateForm);
